/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'
import { Box } from '@chakra-ui/react'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const SimpleClockIconOutline = createIcon({
  displayName: 'SimpleClockIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M16.641 16l-4.922-2.936v-6.328"></path>
        <path d="M18.364 5.63604c3.51472 3.51472 3.51472 9.2132 0 12.7279 -3.51472 3.51472-9.2132 3.51472-12.7279 0 -3.51472-3.51472-3.51472-9.2132-1.77636e-15-12.7279 3.51472-3.51472 9.2132-3.51472 12.7279-1.77636e-15"></path>
      </g>
      <path fill="none" d="M0 0h24v24h-24Z"></path>
    </>
  ),
})

const SimpleClockIconFilled = createIcon({
  displayName: 'SimpleClockIconFilled',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <Box as="path" strokeWidth="2.5" d="M16.641 16l-4.922-2.936v-6.328" stroke="primary.500"></Box>
        <path d="M18.364 5.63604c3.51472 3.51472 3.51472 9.2132 0 12.7279 -3.51472 3.51472-9.2132 3.51472-12.7279 0 -3.51472-3.51472-3.51472-9.2132-1.77636e-15-12.7279 3.51472-3.51472 9.2132-3.51472 12.7279-1.77636e-15"></path>
      </g>
      <path fill="none" d="M0 0h24v24h-24Z"></path>
    </>
  ),
})

const SimpleClock: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
    case 'filled':
      return <CustomIcon as={SimpleClockIconFilled} {...props} />
    default:
      return <CustomIcon as={SimpleClockIconOutline} {...props} />
  }
}

export default memo(SimpleClock)
